import styled from 'styled-components';
import BaseVehicleIcon from '#/shared/components/VehicleIcon';

export const MessageBlock = styled.div`
  margin-left: 10px;
  line-height: 1;
`;

export const VehicleIcon = styled(BaseVehicleIcon).attrs({
  width: '100%',
  height: '100%',
  title: 'Vehicle Type',
  role: 'presentation',
})`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const RouteBadgeWrapper = styled.div`
  position: relative;
  left: 10%;
  top: 10%;
`;
